import localhost, { downloadFileFromResponse } from "apis/localhost";
import { showErrorModal } from "slices/app/actions/error";
import { addToJobQueue, removeFromJobQueue } from "slices/app/appSlice";
import {
  DOCUMENT_EDITOR_CONFIG,
  removeDocument as removeDocumentFromWriting,
} from "slices/writing/documents/documentsSlice";

import {
  removeDocument,
  setDocTypes,
  setDocuments,
  updateDocumentType,
} from "./documentUploadsSlice";

export const fetchDocumentsByEntityType = async (
  dispatch,
  {
    onSuccessAction = () => {},
    entityId,
    entityType,
    originFilter = null,
    silent = false,
  } = {}
) => {
  if (!silent) {
    dispatch(addToJobQueue("getDocuments"));
  }

  try {
    const params = new URLSearchParams({ entityId, entityType });
    if (originFilter) {
      params.append("originFilter", originFilter);
    }
    const url = `/nextgen/document?${params.toString()}`;
    const rsp = await localhost.get(url);
    const data = rsp?.data || [];

    dispatch(onSuccessAction({ documents: data, entityType }));

    return data;
  } catch (err) {
    dispatch(showErrorModal(err));
  } finally {
    if (!silent) {
      dispatch(removeFromJobQueue("getDocuments"));
    }
  }
};

export const getDocuments =
  (entityId, entityType, originFilter = null, { silent = false } = {}) =>
  async (dispatch) => {
    const params = {
      onSuccessAction: setDocuments,
      entityId,
      entityType,
      originFilter,
      silent,
    };
    return await fetchDocumentsByEntityType(dispatch, params);
  };

export const getDocTypes = (entityType) => async (dispatch) => {
  dispatch(addToJobQueue("getDocTypes"));

  try {
    const response = await localhost.get("/nextgen/document/types");
    const { data } = response;
    dispatch(setDocTypes({ docTypes: data, entityType }));
  } catch (error) {
    dispatch(showErrorModal(error));
  } finally {
    dispatch(removeFromJobQueue("getDocTypes"));
  }
};

export const updateType = (docId, type, entityType) => async (dispatch) => {
  try {
    const response = await localhost.patch("/nextgen/document", {
      id: docId,
      type: type,
    });

    if (response.status === 200) {
      dispatch(updateDocumentType({ id: docId, type, entityType }));
    }
  } catch (error) {
    dispatch(showErrorModal(error));
  } finally {
    dispatch(removeFromJobQueue("updateType"));
  }
};

export const downloadDocument = (id, name) => async (dispatch) => {
  dispatch(addToJobQueue("downloadDocument"));

  try {
    const { data } = await localhost.get(`/nextgen/document/${id}/download`, {
      responseType: "blob",
    });
    downloadFileFromResponse(data, name);
  } catch (error) {
    dispatch(showErrorModal(error, "Unable to download document"));
  } finally {
    dispatch(removeFromJobQueue("downloadDocument"));
  }
};

export const deleteDocument = (id, entityType) => async (dispatch) => {
  dispatch(addToJobQueue("deleteDocument"));

  try {
    const response = await localhost.delete(`/nextgen/document/${id}`);

    if (response.status === 200) {
      dispatch(removeDocument({ id, entityType }));
      if (DOCUMENT_EDITOR_CONFIG[entityType]) {
        dispatch(removeDocumentFromWriting({ id, entityType }));
      }
    }
  } catch (error) {
    dispatch(showErrorModal(error));
  } finally {
    dispatch(removeFromJobQueue("deleteDocument"));
  }
};
